import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Store} from '@ngrx/store';
import {userIsSuperAdminSelector} from '../../user/user.reducer';
import {SynchronizationFacadeService} from '../synchronization-facade.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-synchronization-configuration-create',
  template: `
      <div *ngIf="hasSuperAdminRole$ | async">
          Superadmin view only!
          <form [formGroup]="formGroup" (submit)="confirm()" class="configuration-create-form">
              <mat-form-field><input [formControlName]="'name'" matInput [placeholder]="'Configuration name'">
              </mat-form-field>
              <mat-form-field><input [formControlName]="'platform'" matInput [placeholder]="'Platform'">
              </mat-form-field>
              <button mat-raised-button (submit)="confirm()">Save configuration</button>
          </form>
      </div>
  `,
  styleUrls: ['./synchronization-configuration-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SynchronizationConfigurationCreateComponent {

  formGroup = new FormGroup({
    name: new FormControl(),
    platform: new FormControl()
  });
  hasSuperAdminRole$ = this.store.select(userIsSuperAdminSelector);

  constructor(private store: Store, private facade: SynchronizationFacadeService) {
  }

  confirm() {
    this.facade.createConfiguration({
      name: this.formGroup.value.name,
      platform: this.formGroup.value.platform.toUpperCase()
    });
  }


}
